export type PhotoUi = {
  canUpload: boolean
  /** Module actions (ADMIN implies both); per-photo rights still come from Photo.canEdit/canDelete. */
  canEdit: boolean
  canDelete: boolean
  canManageStructure: boolean
  canExport: boolean
  isAdmin: boolean
  isInternal: boolean
  userId: string
}

export type PhotoActions = { canCreate: boolean; canEdit: boolean; canDelete: boolean; canExport: boolean; canAdmin: boolean }

const INTERNAL_RIGHTS = ['OWNER', 'ADMIN', 'USER']

export const photoUi = (userId: string, rights: string | undefined, actions: PhotoActions): PhotoUi => {
  const isInternal = !!rights && INTERNAL_RIGHTS.indexOf(rights) >= 0
  const isAdmin = actions.canAdmin
  return {
    canUpload: actions.canCreate,
    canEdit: isAdmin || actions.canEdit,
    canDelete: isAdmin || actions.canDelete,
    canManageStructure: isAdmin || (actions.canEdit && isInternal),
    canExport: actions.canExport,
    isAdmin,
    isInternal,
    userId,
  }
}

/** Which viewer inputs are enabled: `own` = title/description/visibility, `organise` = tags/folder/location/trade. */
export const editableFields = (photo: { canEdit: boolean; uploadedBy: { id: string } }, ui: PhotoUi): { own: boolean; organise: boolean } => {
  if (!photo.canEdit) return { own: false, organise: false }
  const own = ui.isAdmin || photo.uploadedBy.id === ui.userId
  return { own, organise: own || ui.isInternal }
}
